import { render, staticRenderFns } from "./ProjectList.vue?vue&type=template&id=d95116f8"
import script from "./ProjectList.vue?vue&type=script&lang=js"
export * from "./ProjectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports